export const defaultState = () => {
  return {
    fetched: false,
    loading: false,
    campaigns: {
      list: [],
      total: 0,
      status: {
        loading: false,
        success: null,
        error: null
      }
    },
    attach: null,
    newCampaign: {
      status: {
        loading: false,
        success: null,
        error: null
      }
    },
    message: "",
    accounts: {
      list: [],
      fetched: false,
      loading: false
    }
  };
};

const state = defaultState();

export default state;
